module.exports = __webpack_public_path__ + "static/accepted_cards_logos-8eb85c79bae072c47c702e9fc5bc5860.jpg";